<template>
	<card no-spacing flat :loading="props.track._loading" max-height="500">
		<card-title v-if="props.track.name">{{ props.track.name }}</card-title>

		<card-text
			v-if="props.track.description || props.track.distance || (props.track.resultTrackingSpots && props.track.resultTrackingSpots.length) || (props.track.info && Object.keys(props.track.info).length)" class="overflow-y-auto" fill>
				<p v-if="props.track.description" class="whitespace-pre-wrap">{{ props.track.description }}</p>

			<loader v-if="props.track._loading" height="50"/>
			<info-list v-else-if="props.track.for_participation" small>
				<info-list-item v-if="props.track.total_distance" :icon="icons.distance"
								:text="`${n(props.track.total_distance / 1000, {minimumFractionDigits: 2, maximumFractionDigits: 2})} km`"/>
				<info-list-item v-if="props.track.rounds" :icon="icons.rounds"
								:text="`${props.track.rounds} ${t('label.rounds')} (je ${n(props.track.distance / 1000, {minimumFractionDigits: 2, maximumFractionDigits: 2})} km)`"/>
				<info-list-item v-if="props.track.resultTrackingSpots && props.track.resultTrackingSpots.length" :icon="icons.result_tracking_spot"
								:text="`${props.track.resultTrackingSpots.length} ${t('label.result_tracking_spots')}`"/>
				<info-list-item v-else-if="props.track.result_tracking_spots_count" :icon="icons.result_tracking_spot"
								:text="`${props.track.result_tracking_spots_count} ${t('label.result_tracking_spots')}`"/>
				<info-list-item v-if="parseInt(props.track.info?.secured)" :text="t('label.secured_track')"/>
				<info-list-item v-if="parseInt(props.track.info?.slipstream)" :text="t('label.slipstream_allowed')"/>
				<info-list-item v-if="parseInt(props.track.info?.road_traffic_act)" :text="t('label.road_traffic_act_mandatory')"/>
			</info-list>
		</card-text>

		<wrapper v-if="(props.editable || props.downloadable)" class="px-16 py-16 lg:px-24 border-box border-t" stretch>
			<btn v-if="props.downloadable" small @click="emit('download')" :title="t('action.download')">
				<Icon :icon="icons.download"/>
				<span v-if="!props.editable">{{ t('action.download') }}</span>
			</btn>
			<template v-if="props.editable">
				<btn small @click="emit('upload')" :title="t('action.track.upload')">
					<Icon :icon="icons.upload"/>
				</btn>
				<btn small @click="emit('move')" :title="t('action.move')">
					<Icon :icon="icons.move"/>
				</btn>
				<btn small color="success" @click="emit('edit')" :title="t('action.edit')">
					<Icon :icon="icons.edit"/>
				</btn>
				<btn small color="error" @click="emit('destroy')" :title="t('action.destroy')">
					<Icon :icon="icons.destroy"/>
				</btn>
			</template>
		</wrapper>

	</card>
</template>

<script setup lang="ts">
import {mdiCellphoneNfc, mdiMapMarkerDistance, mdiTimelineClockOutline, mdiUpdate} from "@mdi/js";
import {cancelIcon, checkIcon, destroyIcon, downloadIcon, editIcon, moveIcon, uploadIcon} from "../../config";
import {useI18n} from '#imports';

const props = defineProps<{
	track: object,
	editable: boolean,
	downloadable: boolean,
}>();
const emit = defineEmits(['download', 'upload', 'move', 'edit', 'destroy']);

const {t, n} = useI18n();

const icons = {
	result_tracking_spot: mdiTimelineClockOutline,
	distance: mdiMapMarkerDistance,
	rounds: mdiUpdate,
	virtual: mdiCellphoneNfc,
	check: checkIcon,
	download: downloadIcon,
	edit: editIcon,
	upload: uploadIcon,
	move: moveIcon,
	destroy: destroyIcon,
	cancel: cancelIcon,
}
</script>